import { Facebook } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { LockedSection } from "@/components/plan/common";

export default function MetaAdsSection({ ads, locked }) {
  const ideas = ads?.campaign_ideas;
  if (!ideas?.length) return null;
  return (
    <LockedSection locked={locked} icon={Facebook} title="Meta campaign ideas">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {ideas.map((c, i) => (
          <div key={`meta-${i}-${(c.hook || c.headline || "").slice(0, 20)}`} className="bg-white border border-zinc-200 rounded-2xl p-5">
            <Badge variant="secondary">{c.objective}</Badge>
            <h5 className="font-medium mt-2">{c.hook}</h5>
            <p className="text-sm text-zinc-600 mt-2">{c.primary_text}</p>
            <div className="text-xs text-zinc-500 mt-3"><span className="font-medium">Audience:</span> {c.audience}</div>
            <div className="text-xs text-zinc-500"><span className="font-medium">Creative:</span> {c.creative_direction}</div>
            <div className="mt-3 flex justify-between text-xs">
              <span className="text-zinc-500">{c.headline}</span>
              <Badge>{c.cta}</Badge>
            </div>
          </div>
        ))}
      </div>
    </LockedSection>
  );
}
